<template>
  <b-modal
    id="modal-error-movement"
    body-class="body-wrapper text-center"
    hide-header
    hide-footer
    centered
  >
    <div class="close-button" @click="hideModal()">×</div>

    <div>
      <img :src="require('@/assets/images/alert-report-danger.png')" width="200" />
    </div>

    <div class="content-wrapper">
      <div class="title-text">{{ $t('routeOptimization.alert.reorderFailed') }}</div>
      <div class="description-text">
        {{ $t('routeOptimization.alert.processTimeout') }}
      </div>
    </div>

    <div class="footer-wrapper">
      <a class="text-primary d-block" @click="hideModal()">{{ $t('global.action.close') }}</a>
    </div>
  </b-modal>
</template>

<script>
export default {
  methods: {
    hideModal() {
      this.$bvModal.hide('modal-error-movement')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep(.modal-dialog) {
  max-width: 360px !important;
  width: 100%;
}

.body-wrapper {
  background-color: $white;
  border-radius: 12px;
  padding: 24px;
  position: relative;

  .close-button {
    position: absolute;
    top: 0px;
    right: 12px;
    font-size: 24px;
    font-weight: bold;
    color: $teal-300;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: $teal;
    }
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
  }

  .title-text {
    font-size: 16px;
    font-weight: bold;
    color: $black;
    padding: 0 12px;
  }

  .description-text {
    font-size: 14px;
    color: $teal-300;
    padding: 0 12px;
  }

  .footer-wrapper {
    margin-top: 24px;
  }

  a {
    font-weight: 500;
    cursor: pointer;
  }
}
</style>
